import {Component, Input, OnInit} from '@angular/core';
import {SelectColumn} from '../../model/column/select-column';
import {Observable} from 'rxjs';
import {BaseComponent} from 'nc-shared';
import {map, takeUntil} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {EnumUtils} from 'nc-utils';

@Component({
  selector: 'nc-select-cell',
  templateUrl: './nc-select-cell.component.html',
  styleUrls: ['./nc-select-cell.component.scss']
})
export class NcSelectCellComponent extends BaseComponent implements OnInit {
  @Input() column: SelectColumn;
  @Input() rowData: any;

  cellValue$: Observable<string>;

  constructor(private translateService: TranslateService) {
    super();
  }

  ngOnInit(): void {
    this.cellValue$ = EnumUtils.toObservableItems(this.column.enumeration).pipe(
      takeUntil(this.destroy$),
      map(data => {
        return data.find(x => {
            return this.translateService.instant(x.text) === this.rowData[this.column.name]
          }
        ).text;
      })
    );
  }
}
